/** Forma mínima de una alerta de observabilidad para leer sus invariantes. */
type AlertWithMetadata = { metadata?: Record<string, unknown> }

/** Ids de los invariantes en warn que dispararon la alerta (el principal primero, sin duplicados). */
export function invariantIdsOf(alert: AlertWithMetadata): string[] {
  const metadata = alert.metadata ?? {}
  const ids: string[] = []
  const main = metadata['invariantId']
  if (typeof main === 'string') ids.push(main)
  const list = metadata['invariants']
  if (Array.isArray(list)) {
    for (const entry of list) {
      const id = (entry as { invariantId?: unknown } | null)?.invariantId
      if (typeof id === 'string' && !ids.includes(id)) ids.push(id)
    }
  }
  return ids
}
